module.exports = __webpack_public_path__ + "static/pexels-4-479ecf111e176eb0b7512a81ffe4a77e.png";